import { styled } from '@mui/system'
import { fontSizes, colors } from '../../consts'

type CardProps = { teamColor?: string }

export const LeaderRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.down('lg')]: {
    justifyContent: 'space-around',
  },
}))

export const LeaderCardCon = styled('div')(({ theme }) => ({
  width: '23%',
  height: '256px',
  borderRadius: '10px',
  border: 'solid 1px #c7c7c7',
  padding: '0',
  margin: theme.spacing(1),
  textAlign: 'center',
  [theme.breakpoints.between('md', 'lg')]: {
    width: '31%',
    height: 230,
  },
  [theme.breakpoints.between('sm', 'md')]: {
    width: '30%',
    height: 230,
  },
  [theme.breakpoints.down('sm')]: {
    width: '45%',
    height: 200,
  },
  '& a': {
    textDecoration: 'none',
    color: colors.text,
  },
}))

export const LeaderCardInner = styled('a')<CardProps>(({ theme }) => ({
  '& .statTitleCon': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '10px 10px 0 0',
    height: 50,
    background: colors.lightestGrey,
    [theme.breakpoints.between('md', 'lg')]: {
      height: 30,
    },
    [theme.breakpoints.between('sm', 'md')]: {
      height: 40,
    },
    [theme.breakpoints.down('sm')]: {
      height: 30,
    },
    '& h3': {
      textTransform: 'uppercase',
      fontWeight: 'bold',
      fontSize: fontSizes.medium,
      textAlign: 'center',
      [theme.breakpoints.down('lg')]: {
        fontSize: fontSizes.small,
      },
    },
  },
  '& .innerInfo': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'space-between',
    justifyContent: 'center',
    height: 200,
    [theme.breakpoints.down('sm')]: {
      height: 150,
    },
    '& .profImgCon': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    '& .name': {
      color: colors.text,
      fontSize: fontSizes.medium,
      fontWeight: 600,
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.small,
      },
    },
    '& .positionText': {
      color: colors.text,
      fontSize: fontSizes.small,
    },
    '& .statNumber': {
      marginTop: '5px',
      fontWeight: 700,
      fontSize: fontSizes.large,
      color: colors.text,
      [theme.breakpoints.down('sm')]: {
        fontSize: fontSizes.medium,
      },
    },
  },

  '& .emptyCard': {
    margin: '10px',
  },
}))
